import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
  OnChanges,
  SimpleChanges,

} from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subject, Subscription, lastValueFrom, takeUntil } from 'rxjs';
import { BackendApiService } from 'src/app/core/services/backend-api';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AoActionDialogComponent } from 'src/app/modules/approving-officer-page/approving-action-dialog/approving-action-dialog.component';
import { ForwardDialogComponent } from '../../forward-dialog/forward-dialog.component';
import {
  BodyPrint,
  PrintDocument,
  WorkflowHeader,
  WorkflowOfficer,
  Actioner
} from 'src/app/shared/models/database-models';
import { Store } from '@ngrx/store';
import {
  MyPurchaseForm,
  StoreDropdowns,
  UserInformation,
} from 'src/app/shared/models/app-models';
import { AddendumDialogComponent } from '../../addendum-dialog/addendum-dialog.component';
import { EmailDialogComponent } from '../../email-dialog/email-dialog.component';
import { FormControl } from '@angular/forms';
import { CeDialogComponent } from '../../ce-dialog/ce-dialog.component';
import { IItemToRequest, VendorTagging } from 'src/app/shared/models/app-models/MyPurchaseForm.model';
import { DialogComponent } from '../../dialog/dialog.component';
import { BudgetAllocation, Item, SaveMyPurchase, Vendor } from 'src/app/shared/models/database-models/SaveMyPurchase.model';
import { updateWholeForm } from 'src/app/core/store/form.actions';
import { FormTransformerPipe } from 'src/app/shared/pipes/form-transformer/form-transformer.pipe';
import { SecurityClassificationId } from 'src/app/shared/models/database-models/SecurityClassification';
import { TaggingState } from 'src/app/core/store/TaggedVendors.reducer';
import { ValidationService } from 'src/app/shared/services/validation.service';
import { ValidationErrorCategory, ValidationErrorMessage } from 'src/app/shared/models/app-models/ValidationErrorMessage.model';
import { BannerService, BannerType } from 'src/app/shared/services/banner.service';
import { PermissionsService } from 'src/app/core/services/permissions/permission.service';
import { environment } from 'src/environments/environment';
import { DocumentLock } from 'src/app/shared/models/database-models/DocumentLock';
import { itemListFrontendToBackendMapper } from 'src/app/modules/shared/utils/format-form-data-for-save';
import { AssignmentList, RFSReady, RfsService } from 'src/app/modules/mypurchase-form/rfs/rfs.service';
import { PurchaseTypeMap, PurchaseType } from "src/app/shared/models/app-models/Approving.model";
import { FileService } from 'src/app/shared/services/file.service';
import moment from 'moment';
import { TagItemVendorService } from 'src/app/modules/mypurchase-form/rfs/tag-item-vendor.service';

import { RfqUpdateComponent } from 'src/app/modules/mypurchase-form/rfq-update/rfq-update.component';
import { RfqItem, RfqOutputData, RfqOutputService } from 'src/app/modules/mypurchase-form/rfq-output/rfq-output.service';
import { MatTableDataSource } from '@angular/material/table';
import { DocumentMainStatus, DocumentSubStatus } from 'src/app/shared/models/database-models/DocumentStatus.model';
import { RfsInfoDialogComponent } from 'src/app/modules/mypurchase-form/rfs-info-dialog/rfs-info-dialog.component';
import { Location } from '@angular/common';
import { pageName } from 'src/app/shared/services/page.service';
import { PurchaseExecutives } from 'src/app/shared/models/database-models/PurchaseExecutives.model';
import { SourcingOutcomeInformation, RFQSummaryRole } from 'src/app/shared/models/app-models/SourcingOutcome.model';
import { KeycloakService } from 'keycloak-angular';

interface RFQData {
  RFQNumber: string;
  RFQDeadline: Date;
  Reason: string;
  VendorName: string;
  NewRFQDeadline: Date | null;
}
@Component({
  selector: 'app-bread-crumbs',
  templateUrl: './bread-crumbs.component.html',
  styleUrls: ['./bread-crumbs.component.scss'],
  providers: [],
})


export class BreadCrumbsComponent implements OnInit, OnDestroy, OnChanges {
  @Input() isReadOnly: boolean = false;
  @Input() navigationRoute: string[] = [];
  @Input() breadCrumbFlow: string[] = [];
  @Input() activePage:String='';
  @Input() currentPageString: string = '';
  @Input() clickHandler?: (args: any) => void;
  @Input() approvalOfficerData!: WorkflowHeader;
  @Input() docStatusCode: string = '';
  @Input() purchaseType: string = '';
  @Input() userRoleOnRfqSummary: string = '';
  @Input() canRecallRFQSummary: boolean = true;
  @Input() isLoading: boolean = false;
  @Output() openRoDialog = new EventEmitter<any>();
  RODialogRef: MatDialogRef<RfsInfoDialogComponent> | null = null
  rfqOutputServiceSubscription?: Subscription;
  @Output() buttonActionHandler = new EventEmitter<any>()
  destroy$: Subject<boolean> = new Subject<boolean>();
  navigationRouteString: string = '';
  permissionData$: Observable<any>
  dagid: string = '';
  //dagId is for RFS flow
  dagId: string = '';
  isRFSReadied: boolean = false;
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  loggedInUsername: string = '';
  loggedInUser: string = '';
  approvalDocStatusCode: string = '';
  @Input() isLocked: boolean = true
  //disable btns
  statusStr: string = '';
  ButtonName: string = '';
  //loader for worklist page... shortcut way. to change.
  showLoader: boolean = false;
  isDisabled: boolean = true;
  isCompleteDisable:boolean =true;
  isPE: boolean = false;
  commentControl: FormControl = new FormControl('');
  workflowOfficers: WorkflowOfficer[] = [];
  itemList: IItemToRequest[] = [];
  dpOptions!: StoreDropdowns;
  documentNo: string = '';
  vendorForm!: Vendor[];
  actioner: Actioner = {
    approver: [],
    recommender: [],
    endorser: [],
    endorsed: [],
    releaser: [],
    recommended: [],
    approved: []
  };
  tenderWorkflowMap: Record<string, string> = {
    Tender: 'TenderApproval',
    'Direct Contracting': 'DirectContractApproval',
  };

  DocumentStatusId: string = '';
  DocumentSubStatusId: string = '';
  DocumentReferenceNumber: string = '';
  form!: MyPurchaseForm;
  approvalCheck: number = 0;
  externalId: string = '';
  rfqDeadlineDateTime: Date = new Date('2024-10-28T16:00:00.000Z'); // // will change login when implement api
  rfqDeadlineDisable: boolean = false;
  mpNumber: string = '';
  MPDocumentNumber:string ='';
  CE: string | null | undefined = null;
  disableEmail: boolean = false;
  buttonDisable: boolean = false;
  // disableUpdateVendor: boolean = false;
  isEditable: boolean = true;
  ctdManagers: string[] = [];
  vendorsTagged: VendorTagging[] = [];
  canEditAnyFields: boolean = false
  amIaAssignedPe: boolean = false
  recalled: boolean=false;
    // rfqDataSource: MatTableDataSource<RFQData> = new MatTableDataSource<RFQData>(
  //   []
  // );
  rfqData: RFQData[] = [];
  rfqItem: RfqItem[] = [];
  pageName = pageName;
  documentMainStatus = DocumentMainStatus;
  documentSubStatus = DocumentSubStatus;
  isUserPE: boolean = false;
  rfqSummary$: Observable<SourcingOutcomeInformation>;
  rfqSummaryDetails: SourcingOutcomeInformation = {} as SourcingOutcomeInformation;
  isRfqSummaryPage: boolean = false;
  isReadyDialogOpen: boolean = false;

  constructor(
    private router: Router,
    private backendService: BackendApiService,
    private formTransformer: FormTransformerPipe,
    private _snackBar: MatSnackBar,
    private bannerService: BannerService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    public rfqOutputService: RfqOutputService,
    private dialogRef: MatDialogRef<DialogComponent>,
    private location: Location,
    private store: Store<{
      form: MyPurchaseForm;
      user: UserInformation;
      tagging: VendorTagging;
      dp: StoreDropdowns;
      rfqSummary: SourcingOutcomeInformation
    }>,
    private validationService: ValidationService,
    private permissionService: PermissionsService,
    private rfsService: RfsService,
    private fileService: FileService,
    private tagItemVendorService: TagItemVendorService,
    private keycloakService: KeycloakService
  ) {
    this.MPDocumentNumber = this.route.snapshot.params['id']?.split(';')[0] as string;
    this.permissionData$ = permissionService.getService().pipe(takeUntil(this.destroy$))
    this.permissionData$.subscribe(data => {
      this.canEditAnyFields = data.ability.can('update', data.formAor) || data.ability.can('update', data.formWoc)
        || data.ability.can('update', data.formBasicInfo) || data.ability.can('update', data.formVendorDoc) || data.ability.can('update', data.formDeadline)
        || data.ability.can('update', data.formSow) || data.ability.can('update', data.formTenderValidity)
    })

    // store
    this.store
      .select('form')
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (MyPurchase: MyPurchaseForm) => {
        this.form = MyPurchase;
        if (this.form.documentStatusId != 15) this.isEditable = false;
        // if(this.form.isRFS) this.disableUpdateVendor = true;
        this.itemList = MyPurchase.ItemList || [];
        this.vendorForm = this.form.VendorsToSource.filter(item => !item.isDeleted && !item.Strikethrough);
        this.DocumentStatusId = this.form.documentStatusId?.toString() ?? '';
        this.DocumentSubStatusId = this.form.documentSubStatusId?.toString() ?? '';
        this.DocumentReferenceNumber = this.form.parentDocumentNo?.toString() ?? '';
        this.CE = this.form.CE;
        if (this.DocumentSubStatusId == '39' || this.DocumentSubStatusId == '40' || this.DocumentSubStatusId == '41' || this.DocumentSubStatusId == '42' || this.DocumentSubStatusId == '43' || this.DocumentSubStatusId == '71') {
          try {
            this.ctdManagers = await lastValueFrom(this.backendService.getCTDManagers())
          } catch (e) {
            console.log(e)
          }
        }
        this.externalId = this.form.generalForm?.external?.id ?? '';
        if (
          [
            SecurityClassificationId.RESTRICTED,
            SecurityClassificationId.CONFIDENTIAL,
            SecurityClassificationId.SECRET,
          ].includes(this.externalId as SecurityClassificationId) || this.hasValidReasonForNotUsingRFQ()
        ) {
          this.disableEmail = true;
        }
        // will change login when implement api
        if (this.rfqDeadlineDateTime.getTime() < new Date().getTime()) {
          this.rfqDeadlineDisable = true;
        }
        this.mpNumber = MyPurchase.documentNo || '';
        if (this.DocumentSubStatusId == '11' || this.DocumentSubStatusId == '16' || this.DocumentSubStatusId == '61'
          || this.DocumentSubStatusId == '53' || this.DocumentSubStatusId == '38') {
          this.isDisabled = false;
          this.isCompleteDisable = false;
        }
      });
    this.store
      .select('dp')
      .pipe(takeUntil(this.destroy$))
      .subscribe(async(dp: StoreDropdowns) => {
        this.dpOptions = dp;
        const rfqOutputData = this.rfqOutputService.rfqOutputData;
        // Fetch RFQ Outputs from backend
        // Output History data requires mapping to UserList, hence dp.UserList needs to be available before fetching RfqOutput
        if (
          this.MPDocumentNumber &&
          (!rfqOutputData ||
            !Array.isArray(rfqOutputData.RFQ) ||
            rfqOutputData.RFQ.length === 0 ||
            rfqOutputData.RFQ[0].MPDocumentNumber !== this.MPDocumentNumber)
        ) {
          await this.rfqOutputService.onFetchRfqOutput(this.MPDocumentNumber);
        }
      });

    this.rfqOutputServiceSubscription = this.rfqOutputService.rfqOutput$.subscribe({
      next: async (rfqOutput): Promise<void> => {
        const rfqItems = rfqOutput?.data?.RFQ;
        // RFQ
        if (Array.isArray(rfqItems) && rfqItems.length > 0) {
          this.rfqItem = rfqItems;
        }
      },
    });



    this.store
      .select('user')
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: UserInformation) => {
        this.loggedInUsername = user.userName;
        this.loggedInUser = user.fullName;
      });
    this.store
      .select('tagging')
      .pipe(takeUntil(this.destroy$))
      .subscribe((tagging) => {
        console.log("save tagging : ", tagging);
        let vendorTaggingSet = new Set();
        this.vendorsTagged = (tagging as unknown as TaggingState).tags.filter(
          (tag) => {
            const tagString = JSON.stringify(tag);
            if (vendorTaggingSet.has(tagString)) {
              return false;
            }
            vendorTaggingSet.add(tagString);
            return true;
          }
        );
        console.log('this.vendorsTagged : ', this.vendorsTagged);
      });
    
      
    this.rfsService.assignmentList$.pipe(takeUntil(this.destroy$)).subscribe((assignmentList: AssignmentList) => {
      this.isRFSReadied = false
      this.amIaAssignedPe = false;

      const data = assignmentList.data
      if (data && data.MPDocumentNumber === this.mpNumber && data.requestorUsername === this.loggedInUsername) {
        this.dagId = data.dagId ?? '';
        if (data.dagId) {
          this.isPE = true
        } else {
          this.isPE = false
        }
      }
    })
    
    this.rfsService.rfsReady$.pipe(takeUntil(this.destroy$)).subscribe((rfsReady: RFSReady) => {
      const data = rfsReady.data
      if (data && data.MPDocumentNumber === this.mpNumber && data.requestorUsername === this.loggedInUsername) {
        this.isRFSReadied = data.isRFSReadied
        this.amIaAssignedPe = !!this.form.ItemList.find(x => x.AddItems.PurchaseExecutive == this.loggedInUsername)
      }
    })

    this.ButtonName = this.route.snapshot.params['itemNo'] ? 'Update' : 'Add';
    this.rfqSummary$ = this.store.select('rfqSummary');
    this.rfqSummary$
      .pipe(takeUntil(this.destroy$))
      .subscribe((summaryData: any) => {
        this.rfqSummaryDetails = summaryData as SourcingOutcomeInformation;
      });
  }

  ngOnInit(){
    const path = this.location.path();  
    this.isRfqSummaryPage = path.includes('rfqSummary');
    this.loadGetPurchaseExecutivesList();
  }

  async loadGetPurchaseExecutivesList() {
    let data: PurchaseExecutives[];
    data = await lastValueFrom(this.backendService.getPurchaseExecutivesList(this.loggedInUsername))
    this.isUserPE = data.length >= 1 ? true : false 
  }

  async openButtonDialog(button : string){
    let obj = {
      MPDocumentNumber: this.mpNumber,
      actioner: this.loggedInUsername,
      dagId: this.dagId
    };
    await lastValueFrom(this.backendService.checkRFSReady(obj)).catch((e)=>{
        this.recalled = e.error.Recalled;
        if(e.error.Recalled){
          this.roDialogPrompt();
        }
    });
 
    if(!this.recalled){
      if(button === 'save'&& !this.isLocked){
        // this.saveVendorTagging()
      }else if(button === 'ready' && !this.isLocked){
        this.openReadyDialog()
      }else if(button == 'unready'&& !this.isLocked){
        // this.UnreadyTagging()
      }
    }
  }

  roDialogPrompt(){
    this.openRoDialog.emit(true);
}

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    // for approving officer page
    if (changes && changes['approvalOfficerData'] && changes['approvalOfficerData'].currentValue) {
      try {
        let data = changes['approvalOfficerData']
          .currentValue as WorkflowHeader;
        this.dagid = data.dag_run_id;
        this.documentNo = data.MPDocumentNumber;
        this.approvalDocStatusCode = data.statusCode;
        let approver: string[] = [];
        let recommender: string[] = [];
        let endorser: string[] = [];
        let endorsed: string[] = [];
        let releaser: string[] = [];
        let approved: string[] = [];
        let recommended: string[] = [];
        if (data.approver) {
          for (let actioner of data.approver.split(',')) {
            if (actioner !== null && actioner !== '') {
              approver.push(actioner);
            }
          }
        }
        if (data.recommender) {
          for (let actioner of data.recommender.split(',')) {
            if (actioner !== null && actioner !== '') {
              recommender.push(actioner);
            }
          }
        }
        if (data.endorser) {
          for (let actioner of data.endorser.split(',')) {
            if (actioner !== null && actioner !== '') {
              endorser.push(actioner);
            }
          }
        }
        if (data.endorsed) {
          for (let actioner of data.endorsed.split(',')) {
            if (actioner !== null && actioner !== '') {
              endorsed.push(actioner);
            }
          }
        }
        if (data.releaser) {
          for (let actioner of data.releaser.split(',')) {
            if (actioner !== null && actioner !== '') {
              releaser.push(actioner);
            }
          }
        }
        if (data.approved) {
          for (let actioner of data.approved.split(',')) {
            if (actioner !== null && actioner !== '') {
              approved.push(actioner);
            }
          }
        }
        if (data.recommended) {
          for (let actioner of data.recommended.split(',')) {
            if (actioner !== null && actioner !== '') {
              recommended.push(actioner);
            }
          }
        }
        this.actioner = {
          approver: approver,
          recommender: recommender,
          endorser: endorser,
          endorsed: endorsed,
          releaser: releaser,
          approved: approved,
          recommended: recommended
        };

        this.actioner = await lastValueFrom(this.backendService.getCoveringOfficers(this.actioner));
        this.UpdateapprovalCase();
        this.workflowOfficers = (
          await lastValueFrom(
            this.backendService.getWorkflowUserList(
              this.documentNo,
              this.dagid,
              this.approvalDocStatusCode
            )
          )
        ).Officer;

      } catch (e) {
        console.log('error passing in data');
      }
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
  async openCEDialog() {
    // to do
    this.dialog.open(CeDialogComponent, {
      data: {
        mpDocumentNumber: this.mpNumber,
        loggedInUsername: this.loggedInUsername,
        CE: this.CE,
        workflowId: this.tenderWorkflowMap[this.currentPageString],
      },
    });
  }
  async openDialog(decision: string, status: string) {
    let dialogTitle = '';
    if (status.trim().toLowerCase() == 'recommended') {
      dialogTitle = 'Recommend';
    } else if (status.trim().toLowerCase() == 'approved') {
      dialogTitle = 'Approve';
    } else if (status.trim().toLowerCase() == 'endorsed') {
      dialogTitle = 'Endorse';
    } else if (status.trim().toLocaleLowerCase() == 'released' || status.trim().toLocaleLowerCase() == 'cereleased') {
      dialogTitle = "Release"
    } else if (
      status.trim().toLowerCase() == 'notrecommended' ||
      status.trim().toLowerCase() == 'notapproved' ||
      status.trim().toLowerCase() == 'notendorsed' ||
      status.trim().toLowerCase() == 'rejected' ||
      status.trim().toLowerCase() == 'notreleased'
    ) {
      dialogTitle = 'Reject';
    }

    if (status.trim().toLowerCase() === 'forward') {
      this.showLoader = false;
      this.dialog.open(ForwardDialogComponent, {
        data: {
          officerList: this.workflowOfficers,
          forwardInfo: {
            actioner: this.loggedInUsername,
            dragId: this.dagid,
            documentNo: this.documentNo,
            statusCode: this.docStatusCode,
          },
        },
      });
    } else {
      this.commentControl.reset('');

      this.dialog.open(AoActionDialogComponent, {
        data: {
          title: dialogTitle,
          inputLabel: 'Comments',
          okBtnLabel: dialogTitle,
          commentControl: this.commentControl,
          isRequired:
            dialogTitle.trim().toLowerCase() == 'reject' ? true : false,
          buttonHandler: async () => {
            await this.processAirflow(decision, status);
          },
        },
      });
    }
  }

  //someone with a lot of time pls move this frequently used (fn) to an utility class.
  openSnackBar(notifMsg: string, type: string = 'success') {
    this._snackBar.open(notifMsg, undefined, {
      verticalPosition: this.verticalPosition,
      panelClass: type == 'success' ? 'snackbar-popup' : 'app-notification-error',
      duration: 5000,
    });
  }

  async queryAirFlow(status: string) {
    let decision: string = '';
    try {
      switch (status) {
        case 'recommended':
          decision = 'Document recommended.';
          break;
        case 'notrecommended':
          decision = 'Document not recommended.';
          break;
        case 'approved':
          decision = 'Document approved.';
          break;
        case 'notapproved':
          decision = 'Document not approved.';
          break;
        case 'endorsed':
          decision = 'Document endorsed.';
          break;
        case 'notendorsed':
          decision = 'Document not endorsed.';
          break;
        case 'released':
          decision = 'Document released.';
          break;
        case 'notreleased':
          decision = 'Document not released.';
          break;
        case 'cereleased':
          decision = 'Document released.';
          break
        default:
          decision = status && status !== '' ? status ?? '' : '';
          break;
      }
      await this.openDialog(decision, status);
    } catch (err) {
      this.showLoader = false;
      this.openSnackBar(decision, "error");
      console.log('Error submitting to airflow due to : ', err);
    }
  }

  async processAirflow(decision: string, status: string) {
    this.showLoader = true;
    this.isLoading = true;
    try {
      let obj;
      if (status == 'cereleased') {
        obj = {
          purchaseID: this.mpNumber,
          user_decision: 'released',
          workflowId: this.tenderWorkflowMap[this.currentPageString],
          status_code: '15',
          actioner: this.loggedInUsername,
          comments: this.commentControl.value,
        };
      } else {
        obj = {
          workflowId: this.approvalOfficerData.workflow_id,
          purchaseID: this.approvalOfficerData.MPDocumentNumber,
          dagid: this.approvalOfficerData.dag_run_id,
          user_decision: status,
          status_code: this.approvalOfficerData.statusCode,
          actioner: this.loggedInUsername,
          comments: this.commentControl.value,
        };

      }

      console.log('the obj to send airflow: ', obj);
      if (obj.status_code == '6' || obj.status_code == '8') {
        await lastValueFrom(
          this.backendService.approveBudget(obj).pipe(takeUntil(this.destroy$))
        );
      } else if (obj.status_code == '0') {
        await lastValueFrom(
          this.backendService
            .recommendBudget(obj)
            .pipe(takeUntil(this.destroy$))
        );
      } else if (obj.status_code == '7') {
        await lastValueFrom(
          this.backendService.endorseBudget(obj).pipe(takeUntil(this.destroy$))
        );
      } else if (obj.status_code == '15') {
        await lastValueFrom(
          this.backendService.releaseBudget(obj).pipe(takeUntil(this.destroy$))
        );
      }
   
      //display decision
      this.openSnackBar(decision);
      //to route out after submitting
      this.showLoader = false;
      this.router.navigateByUrl('/worklist');
      this.dialog.closeAll();
    } catch (err: any) {
      this.showLoader = false;
      const errorMessage = err?.error?.message
        ?? err?.error?.errors
        ?? err?.message
        ?? 'An unknown error occurred';
      this.openSnackBar(errorMessage as string, "error");
      console.log('Error submitting to airflow due to : ', err);
    } finally {
      this.isLoading = false;
    }
  }

  // function to show current nested route
  // navigationRouteDisplay() {
  //   for (let i = 0; i < this.navigationRoute.length; i++) {
  //     this.navigationRouteString += this.navigationRoute[i] + ' / ';
  //   }
  // }

  navigateToRoute(event: any) {
    const clickedPath = (event.target as HTMLElement).innerText;
    let urlNavigation = this.setUrlNavigationString(clickedPath);
    this.router.navigateByUrl(urlNavigation)
  }
  setUrlNavigationString(breadcrumbNavigationRoute: string) {
    let urlNavigation: string = ''
    if (breadcrumbNavigationRoute.includes('Request For Quotation')) {
      if (this.form.documentNo && this.form.documentNo.length > 0)
        urlNavigation = `/purchase/rfq/${this.form.documentNo}`;
      else urlNavigation = "/purchase/rfq/draft"
    }
    else if (breadcrumbNavigationRoute.includes('Tender')) {
      if (this.form.documentNo && this.form.documentNo.length > 0)
        urlNavigation = `/purchase/tender/${this.form.documentNo}`;
      else urlNavigation = "/purchase/tender/draft"
    }
    else if (breadcrumbNavigationRoute.includes('Direct')) {
      if (this.form.documentNo && this.form.documentNo.length > 0)
        urlNavigation = `/purchase/dc/${this.form.documentNo}`;
      else urlNavigation = "/purchase/dc/draft"
    }
    else if (breadcrumbNavigationRoute.includes('Corporate')) {
      if (this.form.documentNo && this.form.documentNo.length > 0)
        urlNavigation = `/purchase/corporatecard/${this.form.documentNo}`;
      else urlNavigation = "/purchase/corporatecard/draft"
    } else if (breadcrumbNavigationRoute.includes(this.MPDocumentNumber) || breadcrumbNavigationRoute.includes('draft')) {
      this.location.back();
    } else if (breadcrumbNavigationRoute.includes('My Documents')) {
      urlNavigation = '/land';
    } else if (breadcrumbNavigationRoute.includes('My Worklist')) {
      urlNavigation = '/worklist';
    } else if (breadcrumbNavigationRoute.includes(pageName.PE_Worklist)) {
      urlNavigation = '/peworklist';
    }
    if (urlNavigation.length > 0) return urlNavigation;
    return '/home'
  }
  async openReadyDialog() {
    if (this.isReadyDialogOpen) return; 
    // Perform validation first, before showing Ready confirmation dialog
    this.showLoader = true;
    const { validTaggedGroups, invalidTaggedGroups } =
      this.tagItemVendorService.getTaggedGroupsForPosting();

    const validationErrorMessages =
      await this.rfsService.validateRFSTaggedGroups(
        validTaggedGroups,
        invalidTaggedGroups
      );

      if (validationErrorMessages && validationErrorMessages.length > 0) {
      // Has validation error
      this.displayBannerErrors(validationErrorMessages);
      this.showLoader = false;
      this.isReadyDialogOpen = false;
      return;
    }
    this.showLoader = false;
    this.bannerService.clearValidationMessages();
    this.isReadyDialogOpen = true;

    this.dialogRef = this.dialog.open(DialogComponent, {
      // height: '300px',
      // width: '650px',
      panelClass: 'item-vendor-dialog',
      hasBackdrop: true,
      data: {
        headerTitle: 'Ready',
        contentMsg: 'After switching your status to "Ready", you will not be able to make changes to the document. However, you can change it back to "Unready" status to regain the rights to edit the document again. The current Request for Sourcing workflow will only be considered complete when all personnel involved click the "Ready" button.',
        btnNameOne: 'Ready',
        btnNameTwo: 'Cancel',
        click: () => {
          this.onRFSReady();
          this.dialogRef.close();
        },
        clickTwo: () => {
          this.dialogRef.close();
        },
      },
    });
    this.dialogRef.afterClosed().subscribe(() => {
      this.isReadyDialogOpen = false;
    });
  }

  onHandleClick(actionType: string) {
    // prevent unwanted click trigger when 
    // isLoading from parent component is true; or
    // when buttonDisabled is true that was toggle in onPrint or exportMPDoc function
    if (this.isLoading || this.buttonDisable) return;
    this.buttonActionHandler.emit({ actionType: actionType });
  }

  onButtonClick(actionType: string) {
    if (!this.buttonDisable || !this.isDisabled) {
      if(actionType === "auditLog-rfq-summary") {
        sessionStorage.setItem('fromPage',pageName.RFQ_Summary);
        this.auditClick();
      }
      console.log(actionType)
      this.buttonDisable = true;
      this.isDisabled = true;
      this.buttonActionHandler.emit({ actionType: actionType });
    }

    setTimeout(() => {
      this.buttonDisable = false;
      this.isDisabled = false;
    }, 2000)

    this.isCompleteDisable = true;
  }

  onUploadAttachment(actionType: string) {
    this.buttonActionHandler.emit({ actionType: actionType });
  }

  async submitRecall() {
    this.showLoader = true;
    try {
      let obj = {
        MPDocumentNumber: this.form.documentNo,
        actioner: this.loggedInUsername,
      };
      console.log('Recall Method Call: ', obj);
      let result;
      result = await lastValueFrom(
        this.backendService.recallDocument(obj).pipe(takeUntil(this.destroy$))
      );

      console.log('result: ', result);
      //display decision
      this.openSnackBar('Document recalled.');
      //to route out after submitting
      setTimeout(() => {
        this.showLoader = false;
        this.router.navigateByUrl('/land');
      }, 3000);
    } catch (err) {
      this.showLoader = false;
      this.openSnackBar('Document failed to be recalled.', "error");
      console.log('Error submitting to airflow due to : ', err);
    }
  }
  async submitTerminate() {
    this.showLoader = true;
    try {
      let obj = {
        purchaseID: this.form.documentNo,
        actioner: this.loggedInUsername,
      };
      console.log('Terminate Method Call: ', obj);
      let result;
      result = await lastValueFrom(
        this.backendService.terminateTenderDocument(obj).pipe(takeUntil(this.destroy$))
      );

      console.log('result: ', result);
      //display decision
      this.openSnackBar('Document Teminated.');
      //to route out after submitting
      setTimeout(() => {
        this.showLoader = false;
        this.router.navigateByUrl('/land');
      }, 3000);
    } catch (err) {
      this.showLoader = false;
      this.openSnackBar('Document failed to be Terminate.', "error");
      console.log('Error submitting to airflow due to : ', err);
    }
  }

  workflowClick() {
    this.router.navigate([this.router.url, 'history']);
  }

  auditClick() {
    console.log('object :>> ');
    this.router.navigate([this.router.url, 'audit-log']);
  }

  private getBannerMessageInHtml(errMsgs: ValidationErrorMessage[]) {
    let result = 'Please correct the errors in the following tabs:';

    let basicErrMessages = errMsgs
      .filter((x) => x.category == ValidationErrorCategory.BasicInformation)
      .map((x) => x.message);
    if (basicErrMessages.length > 0) {
      result += `<br><b>Basic information</b><br><ul><li>${basicErrMessages.join(
        '</li><li>'
      )}</ul></li>`;
    }
    let itemErrMessages = errMsgs
      .filter((x) => x.category == ValidationErrorCategory.ItemVendor)
      .map((x) => x.message);
    if (itemErrMessages.length > 0) {
      result += `<br><b>Item / Vendor</b><br><ul><li>${itemErrMessages.join(
        '</li><li>'
      )}</ul></li>`;
    }
    let attachmentErrMessages = errMsgs
      .filter((x) => x.category == ValidationErrorCategory.Attachments)
      .map((x) => x.message);
    if (attachmentErrMessages.length > 0) {
      result += `<br><b>Attachments</b><br><ul><li>${attachmentErrMessages.join(
        '</li><li>'
      )}</ul></li>`;
    }
    let taggingErrMessages = errMsgs
      .filter((x) => x.category === ValidationErrorCategory.Tagging)
      .map((x) => x.message);
    if (taggingErrMessages.length > 0) {
      result += `<br><b>Tagging</b><br><ul><li>${taggingErrMessages.join(
        '</li><li>'
      )}</ul></li>`;
    }
    return result;
  }

  displayBannerErrors(errorMessages: ValidationErrorMessage[]) {
    let finalMessageInHtml: string = this.getBannerMessageInHtml(
      errorMessages
    );
    this.bannerService.addMessage(
      { content: finalMessageInHtml, type: BannerType.error },
      this.mpNumber || (Math.random() + 1).toString(36).substring(7)
    );
  }

  async onRFSSave() {
    this.showLoader = true;
    const result = await this.rfsService.onPostRFSSave();
    // No validation for save
    const { isSuccess, errorMessage } = result ?? {};

    // API error
    if (errorMessage) {
      this.showLoader = false;
      console.log(`onRFSSave error: ${errorMessage}`);
      this.openSnackBar(
        "Encountered error while saving RFS details.",
        'error'
      );
      return;
    }

    // API success
    if (isSuccess) {
      this.showLoader = false;
      this.openSnackBar(
        "RFS details have successfully been saved."
      );
      await this.loadData();
      return;
    }
  }

  async onRFSReady() {
    this.showLoader = true;
    const result = await this.rfsService.onPostRFSReady();
    const { validationErrorMessages, isSuccess, errorMessage } = result ?? {};

    // Validation error
    if (validationErrorMessages) {
      this.displayBannerErrors(validationErrorMessages);
      this.showLoader = false;
      this.openSnackBar(
        "Unable to update document RFS status to 'Ready' due to validation error(s).",
        'error'
      );
      return;
    } else {
      this.bannerService.clearValidationMessages();
    }

    // API error
    if (errorMessage) {
      this.showLoader = false;
      console.log(`onRFSReady error: ${errorMessage}`);
      this.openSnackBar(
        "Your document RFS status failed to update to 'Ready'.",
        'error'
      );
      return;
    }

    // API success
    if (isSuccess) {
      this.showLoader = false;
      this.openSnackBar(
        "Your document RFS status has successfully been updated to 'Ready'."
      );
      await this.loadData();
      return;
    }
  }

  async onRFSUnready() {
    this.showLoader = true;

    const result = await this.rfsService.onPostRFSUnready()
    const {isSuccess, errorMessage} = result ?? {};

    if (errorMessage) {
      this.showLoader = false;
      console.log(`onRFSUnready error: ${errorMessage}`)
      this.openSnackBar("Your document RFS status failed to update to 'Unready'.", "error");
      return
    }

    if (isSuccess) {
      this.showLoader = false;
      this.openSnackBar("Your document RFS status has successfully been updated to 'Unready'.")
      return
    }
  }


  async loadData() {
    // getting data from server and updating the header
    this.showLoader = true;
    let draftForm: SaveMyPurchase = await lastValueFrom(
      this.backendService.getDraft(this.mpNumber)
    );
    let transFormedDraftForm: MyPurchaseForm = this.formTransformer.transformInverse(
      draftForm,
      this.dpOptions
    );
    this.store.dispatch(updateWholeForm({ form: transFormedDraftForm }));

    // Tagging for item-vendor
    if (transFormedDraftForm.documentNo && (transFormedDraftForm.TaggedGroups || transFormedDraftForm.documentStatusId === 15)) {
      this.tagItemVendorService.setTaggedGroupsIfDocNumberChanged(transFormedDraftForm.documentNo, transFormedDraftForm.TaggedGroups ?? [])
    }
    this.showLoader = false;
  }
  canOfficerApproveMoreThanOnce(actionData: Actioner, username: string) {
    let approvingCount = 0
    let approvedCount = 0
    actionData.approver.forEach(x => {
      if (x.toLocaleString().toLowerCase().includes(username))
        approvingCount++
    })
    actionData.approved.forEach(x => {
      if (x.toLocaleString().toLowerCase().includes(username))
        approvedCount++
    })
    return approvedCount < approvingCount
  }
  canOfficerRecommendMoreThanOnce(actionData: Actioner, username: string) {
    let recommendingCount = 0
    let recommendedCount = 0
    actionData.recommender.forEach(x => {
      if (x.toLocaleString().toLowerCase().includes(username))
        recommendingCount++
    })
    actionData.recommended.forEach(x => {
      if (x.toLocaleString().toLowerCase().includes(username))
        recommendedCount++
    })
    return recommendedCount < recommendingCount
  }
  canOfficerEndorseMoreThanOnce(actionData: Actioner, username: string) {
    let endorsingCount = 0
    let endorsedCount = 0
    actionData.endorser.forEach(x => {
      if (x.toLocaleString().toLowerCase().includes(username))
        endorsingCount++
    })
    actionData.endorsed.forEach(x => {
      if (x.toLocaleString().toLowerCase().includes(username))
        endorsedCount++
    })
    return endorsedCount < endorsingCount
  }
  UpdateapprovalCase() {
    console.log(this.loggedInUser);
    console.log(this.loggedInUsername.trim().toLowerCase());
    // matching of status to display the breadcrumb buttons based on the status
    console.log(this.actioner, this.loggedInUsername);
    console.log('update approval case', this.approvalDocStatusCode)
    console.log('update approval case', this.loggedInUsername)
    console.log('update approval case actioner', this.actioner)
    console.log('update approval case', this.loggedInUsername.trim().toLocaleLowerCase())
    console.log('update approval case data', this.approvalOfficerData)
    if (
      this.approvalDocStatusCode == '0' &&
      ((this.actioner.recommender.toLocaleString().toLowerCase().includes(this.loggedInUsername.trim().toLowerCase()) &&
        !this.actioner.recommended.toLocaleString().toLowerCase().includes(
          this.loggedInUsername.trim().toLocaleLowerCase()
        )) || (this.canOfficerRecommendMoreThanOnce(this.actioner, this.loggedInUsername.trim().toLowerCase())))
    ) {
      console.log('1');
      this.approvalCheck = 1;
      return;
    } else if (
      (this.approvalDocStatusCode == '6' || this.approvalDocStatusCode == '8') &&
      ((this.actioner.approver.toLocaleString().toLowerCase().includes(this.loggedInUsername.trim().toLowerCase()) &&
        !this.actioner.approved.toLocaleString().toLowerCase().includes(
          this.loggedInUsername.trim().toLocaleLowerCase()
        )) || (this.canOfficerApproveMoreThanOnce(this.actioner, this.loggedInUsername.trim().toLowerCase())))
    ) {
      console.log('2', this.actioner.approved, this.loggedInUser);
      this.approvalCheck = 2;
      return;
    } else if (
      this.approvalDocStatusCode == '7' &&
      ((this.actioner.endorser.toLocaleString().toLowerCase().includes(
        this.loggedInUsername.trim().toLocaleLowerCase()
      ) &&
        !this.actioner.endorsed.toLocaleString().toLowerCase().includes(
          this.loggedInUsername.trim().toLocaleLowerCase()
        )) || (this.canOfficerEndorseMoreThanOnce(this.actioner, this.loggedInUsername.trim().toLowerCase())))
    ) {
      console.log('3');
      this.approvalCheck = 3;
      return;
    } else if (
      this.approvalDocStatusCode == '15' &&
      this.actioner.releaser.toLocaleString().toLowerCase().includes(
        this.loggedInUsername.trim().toLocaleLowerCase()
      )
    ) {
      console.log('4');
      this.approvalCheck = 4;
      return;
    }
    this.approvalCheck = 0;
    console.log('update approval case final', this.approvalCheck)
    return;
  }

  onOutPutHistory() {
    this.router.navigate([this.router.url, 'output']);
  }

  onRFQOutputClick() {
    this.router.navigate([this.router.url, 'rfq-output']);
  }

  onAddendum() {
    this.dialog.open(AddendumDialogComponent, {
      width: '600px',
      hasBackdrop: true,
    });
  }
  onEmail() {
    this.dialog.open(EmailDialogComponent, {
      width: '600px',
      hasBackdrop: true,
    });
  }
  // updateAndSendRFQ() {
  //   this.dialog.open(RfqUpdateComponent, {
  //     width: '600px',
  //     hasBackdrop: true,
  //   });
  // }

  async updateAndSendRFQ() {
    try {
      this.rfqData = await this.formatRFQDataSource(this.rfqItem);
      if(this.rfqData.length > 0){
        let dialogRef = this.dialog.open(RfqUpdateComponent, {
          width: '950px',
          maxHeight: '80vh',
          data: {
            rfqData: this.rfqData,
          }
        });
      }else{
        this.openSnackBar(
          'No update detected',
          "error"
        );
      }
    } catch (err) {
      console.log(
        'Failed to re-fetch RFQ Output page data after updateAndSendRFQ',
        err
      );
    }
  }

  async formatRFQDataSource(rawData: RfqOutputData['RFQ']) {
    const rfqNumberToData: {
      [key: string]: {
        RFQNumber: string;
        RFQDeadline: Date;
        Reason:string;
        VendorNames: Set<string>;
        OtherVendors: any[];
        newRFQDeadline?: Date;
      };
    } = {};

    // Group data by RFQNumber
    for (const doc of rawData) {
      const {
        RFQNumber,
        vendor,
        mpVendorDetails,
        RFQDeadline,
        newRFQDeadline,
      } = doc;
      const vendorName = vendor?.Name;
      const OtherVendorEmail = mpVendorDetails ? mpVendorDetails[0]?.OtherPersonEmail : null;
      const OtherVendorName = mpVendorDetails ? mpVendorDetails[0]?.OtherPersonName : null;
      const VendorNumber = mpVendorDetails ? mpVendorDetails[0]?.VendorNumber : null;

      const reason = "";
      if (!rfqNumberToData[RFQNumber]) {
        rfqNumberToData[RFQNumber] = {
          RFQNumber,
          RFQDeadline,
          Reason:reason,
          VendorNames: new Set(vendorName ? [vendorName] : []),
          OtherVendors: [],
          newRFQDeadline,
        };
      }
      // Add to VendorNames set
      if (vendorName) {
        rfqNumberToData[RFQNumber].VendorNames.add(vendorName);
      }
      if (OtherVendorEmail || OtherVendorName) {
        rfqNumberToData[RFQNumber].OtherVendors.push({
          OtherPersonName: OtherVendorName || "",
          OtherPersonEmail: OtherVendorEmail || "",
          VendorNumber:VendorNumber || ""
        });
      }
    }
    const dataSourceData = [];
    let status : boolean | undefined;
    // Format to table row
    for (const [RFQNumber, data] of Object.entries(rfqNumberToData)) {

      status = this.checkVenderEmailNameduplicate(data.OtherVendors)
      let reason = '';
      let newRFQDeadline: Date | undefined
       if(status === false){
        let rfqDeadline = this.form.RFQDeadline;
        let updaterfqDeadline = moment(new Date()).add(rfqDeadline, 'days').endOf('day').toDate();
        if(data.newRFQDeadline && data.newRFQDeadline > updaterfqDeadline){
          newRFQDeadline = moment(data.newRFQDeadline).endOf('day').toDate();
          reason = 'Change in vendor email and RFQ deadline'
        }else if(data.newRFQDeadline && data.newRFQDeadline < updaterfqDeadline){
          newRFQDeadline = updaterfqDeadline
          reason = 'Change in vendor email and RFQ deadline'
        }else{
          if(moment(data.RFQDeadline) < moment(updaterfqDeadline)){
            newRFQDeadline = updaterfqDeadline
          }else{
            newRFQDeadline = data.RFQDeadline
          }
          reason = 'Change in vendor email'
        }
      }else{
          if(data.newRFQDeadline){
          newRFQDeadline = data.newRFQDeadline
          reason = 'Change in RFQ deadline'
        }
      }
      if(newRFQDeadline) {
        dataSourceData.push({
          RFQNumber: data.RFQNumber,
          RFQDeadline: data.RFQDeadline,
          Reason: reason,
          VendorName: Array.from(data.VendorNames).join(', '),
          NewRFQDeadline: newRFQDeadline ?? null
        });
      }
    }
    return dataSourceData;
  }

  checkVenderEmailNameduplicate(rfqNumberToData:any){
    let matchResults: boolean[] = [];
    rfqNumberToData.forEach((vendor: any) => {
      const vendorNumber = vendor.VendorNumber;
      const OtherPersonEmail = vendor.OtherPersonEmail;
      const OtherPersonName = vendor.OtherPersonName;

      const filterVendorInfo = this.vendorForm.find((vendor) => vendorNumber && vendor.VendorNumber === vendorNumber);
      const isMatch = filterVendorInfo ?
        (filterVendorInfo.OtherPersonName === OtherPersonName &&
          filterVendorInfo.OtherPersonEmail === OtherPersonEmail)
        : false;
      matchResults.push(isMatch);
    });
    if (matchResults.includes(false)) {
      return false;
    }else{
      return true;
    }
  }

  async onPrint() {
    this.buttonDisable = true;
    if(!this.isPrintAllowed()){
      try {
        const body: BodyPrint = {
          MPDocumentNumber: this.mpNumber,
          User: this.loggedInUsername,
        };
        const result: PrintDocument = await lastValueFrom(
          this.backendService.getRFQs(body).pipe(takeUntil(this.destroy$))
        );
        const arrayBuffer: any = result.Document.data;
        const int8Array = new Uint8Array(arrayBuffer);
        let file = new Blob([int8Array], { type: 'application/pdf' });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      } catch (err) {
        this.openSnackBar('RFQ print failed to send.', "error");
      }
    }
    this.buttonDisable = false;
  }

  public get lCurrentPageString() {
    return this.currentPageString?.trim()?.toLowerCase() ?? ''
  }

  async exportMPDoc() {
    this.buttonDisable = true;
    const MPDocumentNumber = this.mpNumber ?? this.documentNo;

    try {
      const result: { data: number[] } = await lastValueFrom(
        this.backendService
          .downloadMPDocumentFile(MPDocumentNumber)
          .pipe(takeUntil(this.destroy$))
      );

      if (!result || !result.data) {
        throw new Error('Export MP Doc failed to download file buffer.');
      }
      const fileArrayBuffer = result.data as Iterable<number>;
      this.fileService.saveFileFromBuffer(fileArrayBuffer, {
        fileName: `MPDoc_${MPDocumentNumber}_${moment().format(
          'DDMMYYYY'
        )}.pdf`,
        isOpenInNewTab: false,
      });
    } catch (err) {
      this.openSnackBar(
        'Export MP PDF - failed to download file content.',
        'error'
      );
    } finally {
      this.buttonDisable = false;
    }
  }

  hasValidReasonForNotUsingRFQ() {
    return !!(
      this.form.generalForm?.reasonForNotUsingRFQ?.value &&
      this.form.generalForm?.reasonForNotUsingRFQ?.value !== environment.optForRFQReasonCode
    );
  }

  isPrintAllowed(){
    const externalClassificationId = this.form.generalForm?.external?.id;
    return (externalClassificationId &&
      (
        [
          SecurityClassificationId.RESTRICTED,
          SecurityClassificationId.CONFIDENTIAL,
          SecurityClassificationId.SECRET,
        ] as string[]
      ).includes(externalClassificationId) &&
      this.form.documentStatusId === DocumentMainStatus.Pending_Quotation &&
      this.form.documentSubStatusId ===
      DocumentSubStatus.Awaiting_Rfq_Generation
    ) ? true : false;
  }

  //RFQ SUmmary Buttons Handler
  // canShowCreateRFQSummary() {
  //   if (this.isUserPE && this.form.PurchaseTypeId === 1 && (this.form.isRFS || this.form.parentDocumentNo) &&
  //     (this.DocumentSubStatusId == this.documentSubStatus.Rfq_Sent.toString() || this.DocumentStatusId == this.documentMainStatus.Completed.toString())) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }
  
  private get rfqSummaryDocumentStatus() {
    return this.rfqSummaryDetails.DocumentStatusId;
  }

  private isStatusIn(statusIds: number[]): boolean {
    if (this.rfqSummaryDocumentStatus === undefined) return false;
    return statusIds.includes(this.rfqSummaryDocumentStatus);
  }

  private isNoQuoteFound() {
    return this.rfqSummaryDetails?.VendorsList?.every(vendor =>
      vendor.QuotationAttachment.length === 0 ||
      vendor.QuotationAttachment.every(att => att.IsDeleted || att.IsStrikethrough)
    );
  }

  checkRFQRole() {
    if (this.userRoleOnRfqSummary === RFQSummaryRole.Assigned_PE ||
      (this.isUserPE && (this.loggedInUsername !== (this.rfqSummaryDetails?.AssignedPE && this.rfqSummaryDetails?.ROName)))) {
      return 'PE';
    } else if (this.userRoleOnRfqSummary === RFQSummaryRole.RO) {
      return 'RO';
    } else if (this.userRoleOnRfqSummary === RFQSummaryRole.Both_PE_RO) {
      return 'BothPEandRO';
    } else if (this.keycloakService.isUserInRole("IT Support")) {
      return 'ITSupport'
    } else {
      return '';
    }
  }

  isRFQSummaryButtonVisible(button: string): boolean {
    switch (button) {
      case 'auditLog':
        return true;
      case 'recall':
        return !this.isStatusIn([1, 2]) && !!this.rfqSummaryDocumentStatus;
      case 'reassign':
        return !(this.userRoleOnRfqSummary === RFQSummaryRole.RO && this.isStatusIn([5, 6]));
      case 'save':
      case 'submit':
        return this.isStatusIn([1, 2]) || !this.rfqSummaryDocumentStatus;
      case 'abort':
        return (this.rfqSummaryDocumentStatus === 3 || this.rfqSummaryDocumentStatus === 4);
      case 'complete':
        return (this.rfqSummaryDocumentStatus === 3 || this.rfqSummaryDocumentStatus === 4);
      default:
        return false;
    }
  }

  isRFQSummaryButtonDisabled(button: string): boolean {
    switch (button) {
      case 'auditLog':
        return !this.rfqSummaryDocumentStatus || this.isStatusIn([1]);
      case 'recall':
        return this.isStatusIn([4, 5, 6]) || (this.isUserPE && this.loggedInUsername !== this.rfqSummaryDetails.AssignedPE);
      case 'reassign':
        return !this.rfqSummaryDocumentStatus || this.isStatusIn([1, 5, 6]);
      case 'save':
        return false;
      case 'submit':
        return this.isUserPE && this.loggedInUsername !== this.rfqSummaryDetails.AssignedPE;
      case 'abort':
        return (this.rfqSummaryDetails.arePOCreated ?? false);
      case 'complete':
        return !(this.rfqSummaryDetails.arePOCreated ?? false);
      default:
        return false;
    }
  }
}
